export default (fieldValue,fieldName,label) => {
    
    var re = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;
    return {
      valid: fieldValue != null ? re.test(fieldValue) : true,
      validationText: "תבנית סיסמה אינה תקינה"
    };
  };
  